import { render, staticRenderFns } from "./GestionCabinet.vue?vue&type=template&id=65f32ad8&"
import script from "./GestionCabinet.vue?vue&type=script&lang=js&"
export * from "./GestionCabinet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports